var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "form",
    {
      staticClass: "cw-tree-item-updater",
      on: {
        submit: function submit($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.elementTitle,
            expression: "elementTitle",
          },
        ],
        attrs: {
          type: "text",
          placeholder: _vm.$gettext("Titel"),
        },
        domProps: {
          value: _vm.elementTitle,
        },
        on: {
          input: function input($event) {
            if ($event.target.composing) return
            _vm.elementTitle = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "button accept",
        attrs: {
          title: _vm.$gettext("Speichern"),
        },
        on: {
          click: _vm.updateElement,
        },
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "button cancel",
        attrs: {
          title: _vm.$gettext("Abbrechen"),
        },
        on: {
          click: _vm.close,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }